import environment from '@environment/'
import api from '@api/api'

const endpoints = environment.managerApi.endpoints

const verifyExistsEffect = async ({ planId }) => await api.get(endpoints.plan.verifyExists.replace(':planId', planId))

export { verifyExistsEffect }
